import OrdersStatisticModule from './OrdersStatisticModule';

export default OrdersStatisticModule;